'use strict'

/**
 * File with common states to save in the store (Vuex)
 *
 * @type {number}
 *
 * @author C Camilo Castellanos
 * @version 1.0.0
 * @since 18/12/2019 10:41 p. m.
 */

export default {
  requestCounterForSpinnerShown: 0,
  changeLanguage: process.env.VUE_APP_I18N_LOCALE,
  generalParameters: null,
  // {
  //   urlLgo: null,
  //   urlLgf: null,
  //   urlBtnAgregador: null,
  //   urlBtnGateway: null,
  //   tiposMonedas: null
  // },
  configColor: {
    primary: '#00a0df',
    secondary: '#a81680'
  },
  alert: {
    type: null,
    text: null,
    timeout: 0,
    show: false
  }
}
